export const LOCALES = {
  ENGLISH: 'en-EN',
  RUSSIAN: 'ru-RU',
};

export default LOCALES;
